'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as a surprised emoji with default color.
 */
export function SurprisedEmojiAnimation(props: IAnimationProps) {
  const loadAnimation = () => import('../raw-json/emojis/surprised-emoji.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="SurprisedEmojiAnimation"
    />
  );
}
